import * as React from "react"
import { OTPInput, OTPInputContext } from "input-otp"
import { Minus } from "lucide-react"

import { cn } from "@/lib/utils"

const InputOTP = React.forwardRef(({ className, containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    containerClassName={cn("flex items-center gap-3 has-[:disabled]:opacity-50", containerClassName)}
    className={cn("disabled:cursor-not-allowed", className)}
    {...props} />
))
InputOTP.displayName = "InputOTP"

const InputOTPGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex items-center gap-3", className)} {...props} />
))
InputOTPGroup.displayName = "InputOTPGroup"

const InputOTPSlot = React.forwardRef(({ index, className, ...props }, ref) => {
  const inputOTPContext = React.useContext(OTPInputContext)
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index]
  const displayChar = char || "*"

  return (
    <div
      ref={ref}
      className={cn(
        "relative flex h-14 w-14 items-center justify-center overflow-hidden rounded-xl border border-border/70 bg-background text-[28px] font-semibold leading-none text-foreground shadow-[0_10px_30px_rgba(15,23,42,0.06)] transition-all",
        isActive && "z-10 border-primary/70 bg-primary/[0.03] shadow-[0_12px_32px_rgba(15,118,110,0.14)] ring-2 ring-primary/10",
        className
      )}
      {...props}>
      <span
        className={cn(
          "absolute inset-0 flex items-center justify-center leading-none",
          !char && "translate-y-[-1px] text-[24px] font-medium text-muted-foreground/45"
        )}
      >
        {displayChar}
      </span>
      {hasFakeCaret && (
        <div
          className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="h-4 w-px animate-caret-blink bg-foreground duration-1000" />
        </div>
      )}
    </div>
  );
})
InputOTPSlot.displayName = "InputOTPSlot"

const InputOTPSeparator = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="separator"
    className={cn("flex h-14 items-center justify-center px-1 text-muted-foreground/50", className)}
    {...props}>
    <Minus className="h-4 w-4" />
  </div>
))
InputOTPSeparator.displayName = "InputOTPSeparator"

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator }
